import { configureStore } from "@reduxjs/toolkit";
import transferReducer from "./transferSlice/transferSlice";

export const store = configureStore({
  reducer: {
    transfer: transferReducer,
  },
});
